import React from 'react';
import { SVGIcon, optimizeContentfulImageUrl } from 'common/components';
import { useClassName, useScrollY } from 'common/hooks';
import './hero-overlays.less';

const classNames = useClassName('CLPHeroOverlays');

const ScrollDownArrow = ({ useFullScreen }) => {
  if (!useFullScreen) return null;
  const { scrollY } = useScrollY();
  const isVisible = scrollY < 100;
  return (
    <div
      className={classNames('scroll-down-arrow', !isVisible ? 'hidden' : '')}>
      <SVGIcon name="scroll-down-arrow" width={20} height={20} />
    </div>
  );
};

const LogoOverlay = ({ logo }) => {
  if (!logo) return null;
  return (
    <div className={classNames('logo-overlay')}>
      <img
        src={optimizeContentfulImageUrl(
          logo.fields.file.url,
          logo.fields.file.contentType
        )}
        className={classNames('logo')}
        alt={logo.fields.file.details?.description || 'Logo'}
      />
    </div>
  );
};

export { ScrollDownArrow, LogoOverlay };
